export default __webpack_public_path__ + "static/media/delete-icon.244b6687.svg";